var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExtraLearning = function SvgExtraLearning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18749 2.8125C5.18749 1.25918 6.44667 0 7.99999 0C9.55331 0 10.8125 1.25918 10.8125 2.8125C10.8125 4.36578 9.55331 5.625 7.99999 5.625C6.44667 5.625 5.18749 4.36578 5.18749 2.8125ZM15.1339 2.86613C14.6457 2.37797 13.8542 2.37797 13.3661 2.86613L9.98222 6.25H6.01772L2.63386 2.86613C2.14573 2.37797 1.35425 2.37797 0.866123 2.86613C0.377959 3.3543 0.377959 4.14574 0.866123 4.63391L4.56249 8.33023V18.75C4.56249 19.4404 5.12214 20 5.81249 20H6.43749C7.12784 20 7.68749 19.4404 7.68749 18.75V14.375H8.31249V18.75C8.31249 19.4404 8.87214 20 9.56249 20H10.1875C10.8778 20 11.4375 19.4404 11.4375 18.75V8.33023L15.1339 4.63387C15.622 4.1457 15.622 3.3543 15.1339 2.86613Z",
    fill: "#EC7963"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExtraLearning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/extra-learning.87c87cc0.svg";
export { ForwardRef as ReactComponent };